export default __webpack_public_path__ + "static/media/Pipe_Mobile.ac37673b.jpg";